import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Axios from 'axios';
import I18n from 'i18n-js';
import { TCITooltip } from '@/components/ui/Tooltip';
import Modal from '../../../common/Modal';
import Form from './Form';

// AIDEV-NOTE: Exported so a parent (e.g. a dropdown menuitem) can render the
// same tooltip text on a higher-level focus target — see AssessmentRow.
export function getDeleteTooltipContent({ disabled, shared }) {
  if (disabled) return I18n.t('assessment_saved_answers_delete_message');
  if (shared) return I18n.t('assessment_unshare_delete_message');
  return I18n.t('delete_this_assessment');
}

export default function DeleteAssessmentButton({
  classNames,
  deleteAssessmentPath,
  disabled,
  shared,
  withTooltip,
}) {
  const [modalIsOpen, setModelIsOpen] = useState(false);

  const _openModal = () => {
    if (disabled || shared) return;

    setModelIsOpen(true);
  };

  const closeModal = () => {
    setModelIsOpen(false);
  };

  const showTooltip = withTooltip && (disabled || shared);

  const button = (
    <button
      className={`${classNames} full-size ${(disabled || shared) && 'link-disabled disabled'}`}
      type="button"
      onClick={_openModal}
    >
      <i aria-hidden className="fa fa-trash" />
      Delete
    </button>
  );

  return (
    <>
      {withTooltip ? (
        <TCITooltip disabled={!showTooltip}>
          <TCITooltip.Trigger asChild>{button}</TCITooltip.Trigger>
          <TCITooltip.Content>{getDeleteTooltipContent({ disabled, shared })}</TCITooltip.Content>
        </TCITooltip>
      ) : button}
      <Modal
        closeModal={closeModal}
        headerText="Delete Assessment"
        isOpen={modalIsOpen}
      >
        <Form
          deleteAssessmentPath={deleteAssessmentPath}
          onSuccess={closeModal}
        />
      </Modal>
    </>
  );
}

DeleteAssessmentButton.propTypes = {
  classNames: PropTypes.string,
  deleteAssessmentPath: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  shared: PropTypes.bool,
  withTooltip: PropTypes.bool,
};

DeleteAssessmentButton.defaultProps = {
  classNames: '',
  shared: false,
  withTooltip: true,
};
